import { useEffect, useRef, useState } from 'react';

function usePageVisible(): boolean {
  const [visible, setVisible] = useState(() => document.visibilityState !== 'hidden');
  useEffect(() => {
    const update = () => setVisible(document.visibilityState !== 'hidden');
    document.addEventListener('visibilitychange', update);
    return () => document.removeEventListener('visibilitychange', update);
  }, []);
  return visible;
}

/**
 * Calls `onElapsed` once after `ms`. The time counts only while the page is visible
 * and `paused` is false. Each pause starts the full time again.
 */
export function useAutoDismiss(ms: number | undefined, paused: boolean, onElapsed: () => void): void {
  const visible = usePageVisible();
  const latest = useRef(onElapsed);
  useEffect(() => {
    latest.current = onElapsed;
  });

  useEffect(() => {
    if (ms === undefined || paused || !visible) return undefined;
    const timer = setTimeout(() => latest.current(), ms);
    return () => clearTimeout(timer);
  }, [ms, paused, visible]);
}
